import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "this-subtitle" };
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = { class: "formBody" };
import { ref } from 'vue';
import { ThemeButton, ThemeLoader, ThemeFormField, ThemeModal } from '../../front/components';
import SubscriptionForm from './app/SubscriptionForm.vue';
import { restRequestTheme } from '../../front/lib/rest-api';
import { dispatchGtmEvent } from '../../front/gtm';
export default /*@__PURE__*/ _defineComponent({
    __name: 'NewsletterApp',
    props: {
        newsletter: {}
    },
    setup(__props) {
        const props = __props;
        const json = props.newsletter.json;
        const email = ref('');
        const accept = ref(false);
        const modal = ref();
        const modalActive = ref(false);
        const loading = ref(false);
        const subscriptionData = ref();
        async function presentModal() {
            var _a;
            const modalInst = modal.value;
            await fetchSubscription();
            if (((_a = subscriptionData.value) === null || _a === void 0 ? void 0 : _a.email) !== email.value) {
                alert('Kunde inte hämta prenumerationsdata');
            }
            else if (modalInst) {
                modalInst.show();
                modalActive.value = true;
                dispatchGtmEvent('SKP.NewsletterForm.shown', {
                    email: email.value,
                });
            }
            else {
                alert('Kunde inte ladda formulär');
            }
        }
        function onModalDismissed() {
            modalActive.value = false;
        }
        function isEmailValid() {
            var _a;
            return (_a = email.value) === null || _a === void 0 ? void 0 : _a.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
        }
        async function fetchSubscription() {
            loading.value = true;
            subscriptionData.value = await restRequestTheme('GET', `editnews/newsletter/optin?email=${encodeURIComponent(email.value)}`).then(resp => resp.payload);
            loading.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(ThemeLoader), { show: loading.value }, null, 8, ["show"]),
                _createElementVNode("h3", _hoisted_1, _toDisplayString(_unref(json).subtitle), 1),
                _createElementVNode("div", {
                    class: "this-description",
                    innerHTML: _unref(json).description
                }, null, 8, _hoisted_2),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(ThemeFormField), {
                        "container-class": "this-emailInput",
                        type: "email",
                        placeholder: "Skriv in din e-postadress...",
                        modelValue: email.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((email).value = $event)),
                        label: "E-post",
                        required: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_unref(ThemeFormField), {
                        "container-class": "this-acceptanceInput",
                        type: "checkbox",
                        modelValue: accept.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((accept).value = $event)),
                        label: _unref(json).acceptance_text
                    }, null, 8, ["modelValue", "label"])
                ]),
                _createVNode(_unref(ThemeButton), {
                    title: "Gå vidare",
                    size: "small",
                    icon: "arrow-right-long",
                    onClick: _cache[2] || (_cache[2] = ($event) => (presentModal())),
                    disabled: !accept.value || !isEmailValid()
                }, null, 8, ["disabled"]),
                _createVNode(_unref(ThemeModal), {
                    ref_key: "modal",
                    ref: modal,
                    onDismissed: _cache[4] || (_cache[4] = ($event) => (onModalDismissed())),
                    classes: ['subscriptionModal']
                }, {
                    default: _withCtx(() => [
                        (modalActive.value && subscriptionData.value)
                            ? (_openBlock(), _createBlock(SubscriptionForm, {
                                key: 0,
                                newsletter: _ctx.newsletter,
                                "subscription-data": subscriptionData.value,
                                onDismiss: _cache[3] || (_cache[3] = ($event) => { var _a; return ((_a = modal.value) === null || _a === void 0 ? void 0 : _a.dismiss()); })
                            }, null, 8, ["newsletter", "subscription-data"]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 512)
            ], 64));
        };
    }
});
